<p-card
  styleClass="{{ roundedSmall ? 'rounded' : 'rounded-2xl' }} {{
    bgTransparent ? 'bg-transparent' : ''
  }} {{ compactCard ? 'compact' : '' }}
  {{ smallPadding ? 'smallPadding' : '' }}
  {{ overviewHeight ? 'overviewHeight' : '' }}
  "
  (click)="onClick($event)"
  [style]="style"
>
  <app-typography
    *ngIf="header"
    [variant]="headerVariant"
    [overrideClass]="'text-start ' + headerPaddingClass"
  >
    <i class="{{ cardHeaderIcon }}"></i>
    {{ header }}</app-typography
  >
  <div [class]="padding">
    <ng-content></ng-content>
  </div>
</p-card>
